import fr from 'facet-rest';

const hiddenFieldNames = [
  'uploadImage',
];

export const CuratedContentArticleOverride = fr.metaOverride()
  .override({ readonly: true }, { hidden: true })
  .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true })
  .nameOverride('name', { ordinal: 0 })
  .nameOverride('contentUrl', { ordinal: 3 })
  .nameOverride('minAge', { ordinal: 4 })
  .nameOverride('maxAge', { ordinal: 5 })
  .nameOverride('targetedHouseholdStatus', { ordinal: 6 })
  .nameOverride('publishedDate', { ordinal: 7 })
  .done();
